import { gql, type TypedDocumentNode } from "@apollo/client";
import type { UpsertCareerIntentInput } from "./career-profile/careerIntentForm";

export type UpsertCareerIntentResponse = {
  upsertCareerIntent: {
    success: boolean;
    message: string | null;
  };
};

export type UpsertCareerIntentVariables = {
  input: UpsertCareerIntentInput;
};

export const UPSERT_CAREER_INTENT_MUTATION: TypedDocumentNode<UpsertCareerIntentResponse, UpsertCareerIntentVariables> =
  gql`
    mutation UpsertCareerIntent($input: BackofficeUpsertCareerIntentInput!) {
      upsertCareerIntent(input: $input) {
        success
        message
      }
    }
  `;

export type UpsertExperienceIndexAssessmentAnswerInput = {
  questionId: string;
  optionId: string;
};

export type UpsertExperienceIndexAssessmentCompetencyInput = {
  competencyId: string;
  answers: UpsertExperienceIndexAssessmentAnswerInput[];
};

export type UpsertExperienceIndexAssessmentAnswersVariables = {
  input: {
    pgaId: string;
    competencies: UpsertExperienceIndexAssessmentCompetencyInput[];
  };
};

export type UpsertExperienceIndexAssessmentAnswersResponse = {
  upsertExperienceIndexAssessmentAnswers: {
    success: boolean;
    message: string | null;
  };
};

export const UPSERT_EXPERIENCE_INDEX_ASSESSMENT_ANSWERS_MUTATION: TypedDocumentNode<
  UpsertExperienceIndexAssessmentAnswersResponse,
  UpsertExperienceIndexAssessmentAnswersVariables
> = gql`
  mutation UpsertExperienceIndexAssessmentAnswers($input: BackofficeUpsertExperienceIndexAssessmentAnswersInput!) {
    upsertExperienceIndexAssessmentAnswers(input: $input) {
      success
      message
    }
  }
`;
